module.exports = __webpack_public_path__ + "static/media/ic_alphypay_payment.a01623de.svg";